<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>Mağaza Güncelle</h4>
      <v-row style="margin-top: 100px;">
        <v-col cols="12" md="4">
          <h4>Mağaza Adı</h4>
          <v-text-field
            v-model="venueData.venueName"
            maxlength="255"
            counter="255"
            :rules="venueNameRules"
            required
            :readonly="this.isAdmin === false"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <h4>Firma</h4>
          <v-select
            v-model="venueData.companyId"
            :items="allCompanyList"
            item-text="companyName"
            item-value="id"
            :readonly="this.isAdmin === false"
            label="Seçiniz"
            data-vv-name="select"
            required
            @change="onCompanyChange"
          ></v-select>
        </v-col>
        <v-col cols="12" md="8"></v-col>
        <template v-if="venueData.companyId == kahveDunyasiId">
          <v-col cols="12" md="4">
            <h4>Mağaza Tipi</h4>
            <v-select
              v-model="chooseVenueStore"
              :items="venueStoreType"
              item-text="name"
              item-value="type"
              label="Seçiniz"
              data-vv-name="select"
              :readonly="this.isAdmin === false"
              required
            ></v-select>
          </v-col>
        </template>
        <v-col cols="12" md="8"></v-col>
        <!-- <v-col cols="12" md="4">
          <h4>Mağaza Resimleri <span style="color:red;">(375 x 285)</span></h4>
          <div v-for="(item,index) in venueImageList" :key="'venueImage'+index">
            <v-row v-if="item.imagePath!=null">
              <v-img :src="item.venueImageUrl" v-if="item.venueImageUrl!=''" style="height:160px;"></v-img>
              <v-col cols="12" md="11">
                <v-file-input
                  show-size
                  accept="image/*"
                  v-model="venueImageList[index].file"
                  @change="previewVenueImageFiles(item,index)"
                  label="Resim değiştir"
                  required
                ></v-file-input>
              </v-col>
              <v-col cols="12" md="1" style="margin-top:12px;">
                <v-btn color="error" @click="removeVenueImage(index)">Çıkar</v-btn>
              </v-col>
            </v-row>

            <v-row v-else>
              <v-img v-if="item.venueImageUrl!=''" :src="item.venueImageUrl" style="height:160px;"></v-img>
              <v-col cols="12" md="11">
                <v-file-input
                  show-size
                  accept="image/*"
                  :rules="fileRules"
                  @change="previewVenueImageFiles(item,index)"
                  v-model="venueImageList[index].file"
                  label="Resim yükle"
                  required
                ></v-file-input>
              </v-col>
              <v-col cols="12" md="1" style="margin-top:12px;">
                <v-btn color="error" @click="removeVenueImage(index)">Çıkar</v-btn>
              </v-col>
            </v-row>
          </div>

          <v-btn color="#4d48f9" style="margin-top:10px;color:white;" @click="addVenueImage()">Ekle</v-btn>
        </v-col> -->

        <v-col cols="12" md="8"></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-btn
            color="#4d48f9"
            style="margin-top: 10px; color: white;"
            @click="addExecutive()"
          >
            YETKİLİ EKLE
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-for="(executive, index) in venueExecutiveList.filter(
          (x) => x.delete != true,
        )"
        :key="index"
      >
        <v-col cols="12" md="2">
          <h4>Yetkili Ad & Soyad</h4>
          <v-text-field
            v-model="
              venueExecutiveList.filter((x) => x.delete != true)[index].fullName
            "
            maxlength="255"
            counter="255"
            required
            :rules="executiveNameRules"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3">
          <h4>Yetkili Ünvan</h4>
          <v-text-field
            v-model="
              venueExecutiveList.filter((x) => x.delete != true)[index].title
            "
            maxlength="255"
            counter="255"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <h4>Yetkili Telefon</h4>
          <v-text-field
            v-model="
              venueExecutiveList.filter((x) => x.delete != true)[index]
                .phoneNumber
            "
            maxlength="15"
            counter="15"
            required
            v-mask="'(###) ### ## ##'"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <h4>&nbsp;</h4>
          <v-btn
            style="margin-top: 10px; color: red;"
            @click="
              deleteExecutive(
                venueExecutiveList.filter((x) => x.delete != true)[index],
              )
            "
          >
            YETKİLİ SİL
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Çalışma Saatleri</h4>
        </v-col>
      </v-row>
      <div v-for="(item, i) in workingHourList" :key="i + 'a'">
        <v-row>
          <v-col
            cols="12"
            md="3"
            style="align-self: center; margin-top: -3px; text-align: center;"
          >
            <h5>{{ item.name }}</h5>
          </v-col>
          <v-col cols="12" md="3">
            <div class="input-container">
              <i class="material-icons hour-icon">access_time</i>
              <div class="container" style="padding-top: 0;">
                <label :for="'openHour-' + i" class="label">Açılış</label>
                <div>
                  <vue-timepicker
                    manual-input
                    hide-dropdown
                    v-model="item.openHour"
                    :disabled="item.close"
                    @change="syncWorkingHoursForOpen"
                    @focus="focusState = 'focused'"
                    @blur="focusState = 'blurred'"
                    @open="dropdownState = 'opened'"
                    @close="dropdownState = 'closed'"
                  ></vue-timepicker>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="input-container">
              <i class="material-icons hour-icon">access_time</i>
              <div class="container" style="padding-top: 0;">
                <label :for="'closeHour-' + i" class="label">Kapanış</label>
                <div>
                  <vue-timepicker
                    manual-input
                    hide-dropdown
                    v-model="item.closeHour"
                    :disabled="item.close"
                    @change="syncWorkingHoursForClose"
                    @focus="focusState = 'focused'"
                    @blur="focusState = 'blurred'"
                    @open="dropdownState = 'opened'"
                    @close="dropdownState = 'closed'"
                  ></vue-timepicker>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox
              v-model="workingHourList[i].close"
              label="Kapalı"
            ></v-checkbox>
          </v-col>
        </v-row>
      </div>

      <v-row>
        <v-col cols="12" md="12">
          <h4>Mağaza Özellikleri</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="3"
          md="3"
          v-for="(item, index) in allResources"
          :id="'resources' + index"
          :key="item.id + 'resources'"
        >
          <v-checkbox
            :label="item.resource"
            v-model="item.checked"
            color="#4d48f9"
            style="padding-top: 0px;"
            @change="resourceStatusChange(item, $event)"
            hide-details
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Anlaşma Tipi</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="3" md="3" v-for="item in planTypes" :key="item">
          <v-radio-group v-model="selectedPlanType">
            <v-radio
              :label="item"
              :value="item"
              color="#4d48f9"
              hide-details
              :readonly="!isAdmin"
              @change="changeSelectedPlanType"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Bardak Boyu Seçenekleri</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-show="coffeeOptionForPlanTypes(coffeeOption)"
          cols="12"
          sm="12"
          md="12"
          v-for="(coffeeOption, index) in allCoffeeOptions"
          :id="coffeeOption.id + '_coffeeOptions_' + index"
          :key="coffeeOption.id + '_coffeeOptions_' + index"
        >
          <v-checkbox
            v-if="coffeeOptionForPlanTypes(coffeeOption)"
            :label="coffeeOption.title"
            v-model="coffeeOption.checked"
            color="#4d48f9"
            style="padding-top: 4px;"
            :readonly="!isAdmin"
            @change="coffeeOptionStatusChange(coffeeOption, $event)"
            hide-details
          ></v-checkbox>
          <v-row v-show="coffeeOption.checked">
            <v-col
              cols="12"
              sm="3"
              md="3"
              v-for="(item, index) in allCoffeeSize.filter(
                (x) => x.coffeeOptionId == coffeeOption.id,
              )"
              :id="
                'coffeeOption_' +
                coffeeOption.id +
                '_' +
                index +
                '_coffee_' +
                item.id
              "
              :key="
                'coffeeOption_' +
                coffeeOption.id +
                '_' +
                index +
                '_coffee_' +
                item.id
              "
              :readonly="!isAdmin"
            >
              <v-img
                :src="item.coffeeSizeImg"
                style="width: 50px; height: 80px;"
              ></v-img>
              <template v-if="coffeeExtras">
                <v-text-field
                  v-model="item.name"
                  label="Kahve hacmi"
                  @input="coffeeNameChange(item, $event)"
                  :readonly="!isAdmin"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="item.milkyCode"
                  label="Sütlü Kod"
                  :readonly="!isAdmin"
                  @input="coffeeMilkyChange(item, $event)"
                ></v-text-field>
                <v-text-field
                  v-model="item.withoutMilkyCode"
                  label="Sütsüz Kod"
                  :readonly="!isAdmin"
                  @input="coffeeWithoutMilkyChange(item, $event)"
                ></v-text-field>
              </template>
              <v-checkbox
                :label="item.coffeeSize"
                v-model="item.checked"
                color="#4d48f9"
                style="padding-top: 0px;"
                :readonly="!isAdmin"
                @change="coffeeStatusChange(item, $event)"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Süt Seçimleri</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="3"
          md="3"
          v-for="item in allMilkTypes"
          :key="item.id + 'milk'"
        >
          <v-checkbox
            :label="item.milkType"
            v-model="item.checked"
            color="#4d48f9"
            @change="milkTypeStatusChange(item, $event)"
            hide-details
          ></v-checkbox>
          <v-text-field
            v-if="coffeeExtras"
            v-model="item.milkTypeCode"
            @input="milkTypeCodeChange(item, $event)"
            :readonly="true"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Adres</h4>
          <v-textarea
            v-model="venueData.address"
            rows="1"
            auto-grow
            maxlength="255"
            counter="255"
            :rules="addressRules"
            :readonly="this.isAdmin === false"
            required
          ></v-textarea>
        </v-col>
        <v-col cols="6" md="6">
          <h4>Şehir</h4>
          <v-select
            v-model="venueData.cityId"
            :items="allCities"
            item-text="name"
            item-value="id"
            :readonly="this.isAdmin === false"
            :rules="cityRule"
            label="Seçiniz"
            data-vv-name="select"
            required
            @change="cityChange(venueData.cityId, $event)"
          ></v-select>
        </v-col>
        <v-col cols="6" md="6">
          <h4>İlçe</h4>
          <v-select
            v-model="venueData.districtId"
            :items="districtList"
            item-text="name"
            item-value="id"
            :readonly="this.isAdmin === false"
            :rules="districtRule"
            label="Seçiniz"
            data-vv-name="select"
            required
            @change="districtChange(venueData.districtId, $event)"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <h4>Konum</h4>
          <h6>Enlem</h6>
          <v-text-field
            v-model="venueData.latitude"
            :rules="locationXRules"
            min="0"
            type="number"
            required
            :readonly="this.isAdmin === false"
          ></v-text-field>
          <h6>Boylam</h6>
          <v-text-field
            v-model="venueData.longitude"
            :rules="locationYRules"
            min="0"
            type="number"
            :readonly="this.isAdmin === false"
            required
          ></v-text-field>
          <v-text-field
            v-model="venueData.code"
            label="Kod"
            readonly="readonly"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6"></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <h4>Aktif/Pasif</h4>
          <v-checkbox
            v-model="isOpen"
            color="#4d48f9"
            :readonly="!this.isAdmin"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="6" v-if="!isOpen">
          <h4>Yakında</h4>
          <v-checkbox
            v-model="isComingSoon"
            color="#4d48f9"
            :disabled="isOpen"
            :readonly="!isAdminOrVenueUser"
          ></v-checkbox>
        </v-col>
        <v-dialog v-model="showDialog" max-width="390">
          <v-card>
            <v-card-title class="headline">Dikkat</v-card-title>

            <v-card-text>
              Mağazayı aktif etmek üzeresiniz. Bu işlemi gerçekleştirmek
              istediğinizden emin misiniz?
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                style="color: #1565c0 !important;"
                text
                @click="showDialog = false"
              >
                İptal
              </v-btn>

              <v-btn
                color="green darken-1"
                style="color: #1565c0 !important;"
                text
                @click="venueUpdate()"
              >
                Devam
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row v-if="isOpen">
        <v-col cols="12" md="6">
          <h4>Yoğun/Tatil Seçenekleri</h4>
          <v-checkbox
            v-model="isBusyOrFree"
            color="#4d48f9"
            :disabled="!isOpen"
            :readonly="!isAdminOrVenueUser"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row v-if="isOpen && isBusyOrFree">
        <v-col
          cols="12"
          sm="3"
          md="3"
          v-for="item in ['Yoğun', 'Tatil']"
          :key="item"
        >
          <v-radio-group
            v-model="busyFreeRadioGroup"
            @change="handleRadioChange"
          >
            <v-radio
              :label="item"
              :value="item"
              color="#4d48f9"
              hide-details
              :disabled="!isBusyOrFree"
              :readonly="!isAdminOrVenueUser"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row v-if="busyFreeRadioGroup === 'Tatil' && isBusyOrFree && isOpen">
        <v-col cols="12" md="12">
          <h4>Tatil Bitiş Tarihi</h4>
        </v-col>
      </v-row>
      <v-row v-if="busyFreeRadioGroup === 'Tatil' && isBusyOrFree && isOpen">
        <v-col cols="12" sm="6" md="4">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            :readonly="!isAdminOrVenueUser"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="venueData.freeEndDate"
                style="font-weight: bold;"
                prepend-icon="event"
                readonly
                v-on="on"
                :required="isRequiredFreeEndDate"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="selectedDate"
              :readonly="!isAdminOrVenueUser"
              :min="tomorrowDate"
              @input="menu = false"
              @change="formatDate(selectedDate)"
              locale="tr"
              show-current
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row v-if="busyFreeRadioGroup === 'Tatil' && isBusyOrFree && isOpen">
        <v-col cols="12" md="12">
          <h4>Kalan Tatil Kullanım Hakları :</h4>
          {{ venueData.remainingFreeUsageRights }}
        </v-col>
      </v-row>
      <v-row v-if="busyFreeRadioGroup === 'Yoğun' && isBusyOrFree && isOpen">
        <v-col cols="12" md="12">
          <h4>Yoğunluk Bitiş Saati</h4>
        </v-col>
      </v-row>
      <v-row v-if="busyFreeRadioGroup === 'Yoğun' && isBusyOrFree && isOpen">
        <v-col cols="12" sm="6" md="4">
          <i class="material-icons hour-icon">access_time</i>
          <vue-timepicker
            manual-input
            hide-dropdown
            v-model="venueData.busyEndTime"
            :disabled="!isAdminOrVenueUser"
            @focus="focusState = 'focused'"
            @blur="focusState = 'blurred'"
            @open="dropdownState = 'opened'"
            @close="dropdownState = 'closed'"
          ></vue-timepicker>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-col cols="12" md="7">
        <v-btn
          depressed
          color="#4d48f9"
          style="text-transform: none !important; float: right; color: white;"
          @click="venueUpdate()"
        >
          GÜNCELLE
        </v-btn>
      </v-col>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="fruit in this.errorList" :key="fruit">{{ fruit }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- <v-row>

      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
const PlanTypes = {
  BasicPlan: 'Basic Paket Anlaşması',
  BasicPlusPlan: 'Basic + Plus Paket Anlaşması',
}
import { mapGetters, mapActions } from 'vuex'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'
import { allErrorList as allErrorListData } from '../../../constants.js'

export default {
  components: {
    VueTimepicker,
  },
  name: 'VenueDetail',
  data: () => ({
    allErrorList: allErrorListData,
    chooseVenueStore: {},
    kahveDunyasiId: 0,
    venueStoreType: [
      { type: 'AG', name: 'Al Götür Mağazası' },
      { type: 'TW', name: 'Bordo Mağaza' },
    ],
    selectVenueStore: '',
    venueMapImageUrl: '',
    valid: true,
    coffeeExtras: false,
    venueNameRules: [
      (v) => !!v || 'Mağaza/Tabela adı alanı zorunludur.',
      (v) =>
        (v != null && v != undefined && v.length <= 255) ||
        'Maksimum 255 karakter olmalıdır.',
    ],
    executiveTitleRules: [
      (v) => !!v || 'Yetkili ünvanı adı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    executiveNameRules: [
      (v) => !!v || 'Yetkili adı & soyadı alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
      (v) => v.trim().length >= 2 || 'Minumum 2 karakter olmalıdır.',
    ],

    executivePhoneRules: [
      (v) => !!v || 'Yetkili telefon alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    addressRules: [
      (v) => !!v || 'Adres alanı zorunludur.',
      (v) =>
        (v != null && v != undefined && v.length <= 255) ||
        'Maksimum 255 karakter olmalıdır.',
    ],
    coffeeNameRules: [(v) => !!v || 'Kahve hacmi alanı zorunludur.'],
    locationXRules: [
      (v) => !!v || 'Enlem alanı zorunludur.',
      (v) => parseFloat(v) > -1 || "Sıralama 0'dan küçük olmamalıdır.",
    ],
    locationYRules: [
      (v) => !!v || 'Boylam alanı zorunludur.',
      (v) => parseFloat(v) > -1 || "Sıralama 0'dan küçük olmamalıdır.",
    ],
    codeRules: [(v) => !!v || 'Kod alanı zorunludur.'],
    fileRules: [
      // value => value.size < 1000 || 'Avatar size should be less than 2 MB!',
      (v) => !!v || 'Resim gereklidir.',
      (v) => (v && v.name != null) || 'Resim gereklidir.',
    ],
    cityRule: [
      // value => value.size < 1000 || 'Avatar size should be less than 2 MB!',
      (v) => !!v || 'Şehir alanı zorunludur.',
    ],
    districtRule: [
      // value => value.size < 1000 || 'Avatar size should be less than 2 MB!',
      (v) => !!v || 'İlçe alanı zorunludur.',
    ],
    allMilkTypes: [],
    selectedMilkTypes: [],
    allCoffeeSize: [],
    allCities: [],
    allCoffeeOptions: [],
    districtList: [],
    districtId: {},
    cityId: 0,
    allResources: [],
    venueMapImage: undefined,
    coffeeSizeList: [],
    milkTypeId: [],
    resourceId: [],
    venueExecutiveList: [],
    coffeeOptionList: [],
    coffeeOptionsForBasicPlan: ['FilterCoffee', 'ColdBrew'],
    selectedPlanType: 'Basic Paket Anlaşması',
    planTypes: PlanTypes,

    venueData: {
      freeEndDate: new Date().toISOString().substr(0, 10), // ISO 8601 default date format
    },
    workingHourList: [
      {
        openHour: null,
        startModal2: false,
        closeHour: null,
        endModal2: false,
        name: 'Pazartesi',
        workingDay: 'Monday',
        close: false,
        tempOpenHour: null,
        tempCloseHour: null,
        tempClose: false,
      },
      {
        openHour: null,
        startModal2: false,
        closeHour: null,
        endModal2: false,
        name: 'Salı',
        workingDay: 'Tuesday',
        close: false,
        tempOpenHour: null,
        tempCloseHour: null,
        tempClose: false,
      },
      {
        startModal2: false,
        openHour: null,
        closeHour: null,
        endModal2: false,
        name: 'Çarşamba',
        workingDay: 'Wednesday',
        close: false,
        tempOpenHour: null,
        tempCloseHour: null,
        tempClose: false,
      },
      {
        openHour: null,
        startModal2: false,
        closeHour: null,
        endModal2: false,
        name: 'Perşembe',
        workingDay: 'Thursday',
        close: false,
        tempOpenHour: null,
        tempCloseHour: null,
        tempClose: false,
      },
      {
        openHour: null,
        startModal2: false,
        closeHour: null,
        endModal2: false,
        name: 'Cuma',
        workingDay: 'Friday',
        close: false,
        tempOpenHour: null,
        tempCloseHour: null,
        tempClose: false,
      },
      {
        openHour: null,
        startModal2: false,
        closeHour: null,
        endModal2: false,
        name: 'Cumartesi',
        workingDay: 'Saturday',
        close: false,
        tempOpenHour: null,
        tempCloseHour: null,
        tempClose: false,
      },
      {
        openHour: null,
        startModal2: false,
        closeHour: null,
        endModal2: false,
        name: 'Pazar',
        workingDay: 'Sunday',
        close: false,
        tempOpenHour: null,
        tempCloseHour: null,
        tempClose: false,
      },
    ],
    venueImageList: [],

    executiveModel: {
      id: null,
      title: '',
      fullName: '',
      phoneNumber: '',
      delete: false,
    },
    errorList: [],
    dialog: false,
    isAdmin: false,
    isAdminOrVenueUser: false,
    showDialog: false,
    coffeeTypesObject: {
      Espresso: 'Espresso',
      Latte: 'Latte',
      IcedLatte: 'IcedLatte',
      Cappuccion: 'Cappuccion',
      FilterCoffee: 'FilterCoffee',
      ColdBrew: 'ColdBrew',
    },
    coffeeSizesObject: {
      Small: 'Small',
      Middle: 'Middle',
      Big: 'Big',
    },
    menu: false,
    currentHour: new Date().getHours(),
    currentMinute: new Date().getMinutes(),
    isBusyOrFree: false,
    isOpen: false,
    isComingSoon: false,
    busyFreeRadioGroup: '',
    selectedDate: new Date().toISOString().substr(0, 10), // ISO 8601 default date format
  }),
  watch: {
    chooseVenueStore: function (val) {
      this.selectVenueStore = val
    },
    venueData: {
      handler(newValue) {
        // Check the status of the open and comingSoon fields in venueData
        this.isOpen = newValue.isOpen
        this.isComingSoon = newValue.isComingSoon

        // Check the status of the busy or free fields in venueData
        if (newValue.isBusy || newValue.isFree) {
          // If any of them are true, set isBusyOrFree to true
          this.isBusyOrFree = true
        } else {
          this.isBusyOrFree = false
        }
        if (newValue.isBusy) {
          this.busyFreeRadioGroup = 'Yoğun'
          this.venueData.isFree = false
          this.venueData.freeEndDate = null
        } else if (newValue.isFree) {
          this.busyFreeRadioGroup = 'Tatil'
          this.venueData.isBusy = false
          this.venueData.busyEndTime = null
        }
      },
    },
    isBusyOrFree(newValue) {
      if (!newValue) {
        // isBusyOrFree false olduğunda busyFreeRadioGroup değerlerini boşalt
        this.busyFreeRadioGroup = ''
        this.venueData.busyEndTime = null
        this.venueData.freeEndDate = null
      }
    },
    isOpen(newValue) {
      if (!newValue) {
        // isOpen false olduğunda isBusyOrFree değerlerini boşalt
        this.isBusyOrFree = false
      } else {
        //isOpen true olduğunda isComingSoon değerlerini boşalt
        this.isComingSoon = false
      }
    },
    // 'venueData.freeEndDate': function (newDate) {
    //   this.formatDate(newDate)
    // },
  },
  computed: {
    ...mapGetters(['allCompanyList']),
    tomorrowDate() {
      var tomorrow = moment(new Date()).add(1, 'days')
      tomorrow.set('hour', 8)
      tomorrow.set('minute', 0)
      tomorrow.set('second', 0)
      return tomorrow.toISOString().substr(0, 10)
    },
    formattedDate() {
      return this.formatDate(this.venueData.freeEndDate)
    },
  },
  created() {
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))

    if (
      userRoles.find((x) => x == 'PanelUser') != null &&
      userRoles.find((x) => x == 'PanelUser') != undefined
    ) {
      this.isAdmin = true
    }

    if (
      this.isAdmin ||
      (userRoles.find((x) => x == 'PanelVenueUser') != null &&
        userRoles.find((x) => x == 'PanelVenueUser') != undefined)
    ) {
      this.isAdminOrVenueUser = true
    }

    let venueObject = {
      id: this.$route.params.id,
    }
    this.getCompanieList().then((companies) => {
      companies.filter((company) => {
        if (company.companyName == 'Kahve Dünyası')
          this.kahveDunyasiId = company.id
      })

      this.getVenue(venueObject).then((venueRes) => {
        this.venueData = venueRes
        if (this.venueData.hasPlusPackage === true) {
          this.selectedPlanType = this.planTypes.BasicPlusPlan
        } else {
          this.selectedPlanType = this.planTypes.BasicPlan
        }
        const selectedCompany = companies.find(
          (company) => company.id == this.venueData.companyId,
        )
        if (selectedCompany && selectedCompany.coffeeExtras)
          this.coffeeExtras = selectedCompany.coffeeExtras == 'True'
        for (let i = 0; i < venueRes.venueExecutive.length; i++) {
          let resItem = Object.assign({}, venueRes.venueExecutive[i])
          resItem.delete = false
          this.venueExecutiveList.push(resItem)
        }
        this.venueMapImageUrl =
          venueRes.url + venueRes.mapImage + '?x=' + Date.now()
        for (let i = 0; i < this.workingHourList.length; i++) {
          let workingData = this.venueData.venueWorkingHourResponse
            ? this.venueData.venueWorkingHourResponse.find(
                (x) => x.workingDay == this.workingHourList[i].workingDay,
              )
            : null
          if (workingData && workingData.openHour) {
            this.workingHourList[i].openHour = workingData.openHour
            this.workingHourList[i].tempOpenHour = workingData.openHour
          }
          if (workingData && workingData.closeHour) {
            this.workingHourList[i].closeHour = workingData.closeHour
            this.workingHourList[i].tempCloseHour = workingData.closeHour
          }
          if (
            this.workingHourList[i].openHour == '00:00' &&
            this.workingHourList[i].closeHour == '00:00'
          ) {
            this.workingHourList[i].close = true
            this.workingHourList[i].tempClose = true
          }
        }

        if (venueRes.images) {
          for (let i = 0; i < venueRes.images.length; i++) {
            this.venueImageList.push({
              imagePath: venueRes.images[i],
              file: null,
              venueImageUrl: (
                this.venueData.url +
                venueRes.images[i] +
                '?x=' +
                Date.now()
              ).toString(),
            })
          }
        }
        this.getCoffeeOptionList().then((coffeeOptionList) => {
          this.allCoffeeOptions = coffeeOptionList
          this.getCoffeeSizeList().then((coffeeSizeList) => {
            coffeeSizeList.forEach((coffeeSize) => {
              coffeeOptionList.forEach((coffeeOption) => {
                const coffeeData = this.venueData.venueCoffeeSize.find(
                  (t) =>
                    t.coffeeSizeType === coffeeSize.coffeeSizeType &&
                    t.coffeeOptionId === coffeeOption.id,
                )

                const isEspressoBigOrMiddle =
                  coffeeOption.coffeeType === this.coffeeTypesObject.Espresso &&
                  (coffeeSize.coffeeSizeType === this.coffeeSizesObject.Big ||
                    coffeeSize.coffeeSizeType === this.coffeeSizesObject.Middle)

                if (isEspressoBigOrMiddle) {
                  return
                }

                this.coffeeSizeList.push({
                  checked: !!coffeeData,
                  id: coffeeSize.id,
                  name: coffeeSize ? coffeeSize.coffeeSize : '',
                  milkyCode: coffeeData ? coffeeData.milkyCode : '',
                  withoutMilkyCode: coffeeData
                    ? coffeeData.withoutMilkyCode
                    : '',
                  coffeeOptionId: coffeeOption.id,
                  coffeeSize: coffeeSize.coffeeSize,
                  coffeeSizeImg: coffeeSize.image,
                  coffeeType: coffeeData
                    ? coffeeData.coffeeType
                    : coffeeOption.coffeeType,
                })

                if (coffeeData) {
                  coffeeSize.checked = true
                  coffeeOption.checked = true
                }
              })
            })

            this.allCoffeeSize = this.coffeeSizeList
          })
        })

        this.getMilkTypeList().then((milkTypeList) => {
          this.allMilkTypes = milkTypeList
          this.allMilkTypes.forEach((item) => {
            if (
              this.venueData.venueMilkType.find((t) => t.id == item.id) !=
              undefined
            ) {
              item.checked = true
              this.milkTypeId.push({ id: item.id, code: item.milkTypeCode })
            } else {
              item.checked = false
            }
          })
          //this.allMilkTypes.forEach( x => this.selectedMilkTypes.push(x.checked === true));
          this.allMilkTypes.forEach((x) => {
            if (x.checked === true) {
              this.selectedMilkTypes.push(x)
            }
          })
        })

        this.getCityList().then((cityList) => {
          this.allCities = cityList
        })
        this.getDistrictList(this.venueData.cityId).then((districtList) => {
          if (!this.venueData.cityId) return
          this.districtList = districtList
        })
        this.getResourceList().then((resourceList) => {
          this.allResources = resourceList.map((item) => {
            if (
              this.venueData.resourceResponses &&
              this.venueData.resourceResponses.find((t) => t.id == item.id) !=
                undefined
            ) {
              item.checked = true
              this.resourceId.push(item.id)
            } else {
              item.checked = false
            }
            return item
          })
        })
        if (this.venueData.venueType == '1') {
          this.selectVenueStore = 'AG'
          this.chooseVenueStore = { type: 'AG', name: 'Al Götür Mağazası' }
        } else {
          this.selectVenueStore = 'TW'
          this.chooseVenueStore = { type: 'TW', name: 'Bordo Mağazası' }
        }
        if (this.venueData.freeEndDate) {
          this.formatDate(this.venueData.freeEndDate)
        }
      })
    })
  },
  methods: {
    ...mapActions([
      'getVenue',
      'getCoffeeOptionList',
      'getCompanieList',
      'getCoffeeSizeList',
      'getResourceList',
      'getMilkTypeList',
      'updateMilkTypes',
      'updateVenue',
      'getCityList',
      'getDistrictList',
    ]),
    routeVenues() {
      this.$router.push('/dashboard/venues')
    },
    addExecutive() {
      if (this.venueExecutiveList.filter((x) => x.delete != true).length < 2) {
        this.venueExecutiveList.push(Object.assign({}, this.executiveModel))
      } else {
        alert('Sadece 2 yetkili eklenebilir')
      }
    },
    deleteExecutive(item) {
      if (item.id == null) {
        this.venueExecutiveList = this.venueExecutiveList.filter(
          (x) => x !== item,
        )
      } else {
        item.delete = true
      }
    },
    coffeeStatusChange(item, newValue) {
      let coffee = this.coffeeSizeList.find(
        (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
      )
      if (coffee != undefined) {
        this.coffeeSizeList.find(
          (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
        ).checked = newValue
      }
    },
    coffeeNameChange(item, newValue) {
      let coffee = this.coffeeSizeList.find(
        (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
      )
      if (coffee != undefined) {
        this.coffeeSizeList.find(
          (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
        ).name = newValue
      }
    },
    coffeeMilkyChange(item, newValue) {
      let coffee = this.coffeeSizeList.find(
        (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
      )
      if (coffee != undefined) {
        this.coffeeSizeList.find(
          (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
        ).milkyCode = newValue
      }
    },
    coffeeWithoutMilkyChange(item, newValue) {
      let coffee = this.coffeeSizeList.find(
        (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
      )
      if (coffee != undefined) {
        this.coffeeSizeList.find(
          (x) => x.id == item.id && x.coffeeOptionId == item.coffeeOptionId,
        ).withoutMilkyCode = newValue
      }
    },
    milkTypeCodeChange(item, newValue) {
      let milkType = (this.milkTypeId.find(
        (x) => x.id == item.id,
      ).code = newValue)
    },
    cityChange(item, newValue) {
      this.getDistrictList(newValue).then((districtList) => {
        this.districtList = districtList
        this.venueData.districtId = null
        this.venueData.cityId = newValue
      })
    },
    districtChange(item, newValue) {
      this.venueData.districtId = newValue
    },
    milkTypeStatusChange(item, newValue) {
      const hasMilk = this.milkTypeId.find((x) => x.id == item.id)

      if (!hasMilk) {
        this.milkTypeId.push({ id: item.id, code: item.milkTypeCode })
        this.selectedMilkTypes.push(item)
      } else {
        this.milkTypeId = this.milkTypeId.filter((x) => x.id != item.id)
        this.selectedMilkTypes = this.selectedMilkTypes.filter((x) => x != item)
      }
    },
    resourceStatusChange(item, newValue) {
      if (newValue) {
        this.resourceId.push(item.id)
      } else {
        this.resourceId = this.resourceId.filter((x) => x != item.id)
      }
    },

    async coffeeOptionStatusChange(item, newValue) {
      if (this.allCoffeeSize.length === 0) {
        const coffeeSizeList = await this.getCoffeeSizeList()

        this.coffeeSizeList = coffeeSizeList.flatMap((size) =>
          this.allCoffeeOptions.map((coffeeOption) => {
            const coffeeSizeData = this.venueData.venueCoffeeSize.find(
              (t) => t.id === size.id && t.coffeeOptionId === coffeeOption.id,
            )

            return coffeeSizeData
              ? {
                  checked: true,
                  id: size.id,
                  name: coffeeSizeData.coffeeSize,
                  milkyCode: coffeeSizeData.milkyCode,
                  withoutMilkyCode: coffeeSizeData.withoutMilkyCode,
                  coffeeOptionId: coffeeOption.id,
                  coffeeSize: size.coffeeSize,
                  coffeeSizeImg: size.image,
                }
              : {
                  checked: false,
                  id: size.id,
                  milkyCode: '',
                  withoutMilkyCode: '',
                  coffeeOptionId: coffeeOption.id,
                  coffeeSize: size.coffeeSize,
                  coffeeSizeImg: size.image,
                }
          }),
        )
        this.allCoffeeSize = [...this.coffeeSizeList]
      }
    },
    addVenueImage() {
      this.venueImageList.push({
        imagePath: null,
        file: null,
      })
    },
    removeVenueImage(index) {
      if (this.venueImageList.length > 0) {
        this.venueImageList.splice(index, 1)
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result.split(',')[1])
        reader.onerror = (error) => reject(error)
      })
    },
    previewFiles() {
      if (this.venueMapImage == undefined) {
        this.venueMapImageUrl = ''
      } else {
        const file = this.venueMapImage
        this.venueMapImageUrl = URL.createObjectURL(file)
      }
    },
    previewVenueImageFiles(item, index) {
      if (this.venueImageList[index].file == undefined) {
        this.venueImageList[index].venueImageUrl = ''
      } else {
        const file = this.venueImageList[index].file
        this.venueImageList[index].venueImageUrl = URL.createObjectURL(file)
      }
    },
    venueMilkControl() {
      if (this.selectedMilkTypes.length === 0) return false

      let flag = false
      this.selectedMilkTypes.forEach((milk) => {
        if (milk.milkType === 'Sütsüz') flag = true
      })

      return !(flag === true && this.selectedMilkTypes.length <= 1)
    },
    workingHourControl(openHour, closeHour) {
      if (
        !openHour ||
        !closeHour ||
        openHour.HH === 'HH' ||
        openHour.HH === '' ||
        openHour.mm === 'mm' ||
        openHour.mm === '' ||
        closeHour.HH === 'HH' ||
        closeHour.HH === '' ||
        closeHour.mm === 'mm' ||
        closeHour.mm === ''
      ) {
        this.errorList = []
        this.errorList.push('Çalışma saatleri boş bırakılamaz.')
        this.dialog = true
        return true
      }
    },
    onCompanyChange() {
      const selectedCompany = this.allCompanyList.find(
        (company) => company.id === this.venueData.companyId,
      )
      if (selectedCompany) {
        this.coffeeExtras = selectedCompany.coffeeExtras == 'True'
      }
    },
    venueUpdate() {
      if (
        !this.venueData.isOpen &&
        this.venueData.isComingSoon &&
        this.isOpen &&
        !this.showDialog
      ) {
        this.showDialog = true
      } else {
        const coffeeOptionIds = this.allCoffeeOptions
          .filter((x) => x.checked)
          .map((x) => x.id)
        let updatedCoffeeSizeList = []
        this.coffeeSizeList
          .filter(
            (x) => coffeeOptionIds.includes(x.coffeeOptionId) && x.checked,
          )
          .forEach((x) => {
            if (this.selectedPlanType === this.planTypes.BasicPlusPlan) {
              updatedCoffeeSizeList.push({
                id: x.id,
                milkyCode: x.milkyCode,
                name: x.name,
                withoutMilkyCode: x.withoutMilkyCode,
                coffeeOptionId: x.coffeeOptionId,
              })
            }
            if (
              (this.selectedPlanType === this.planTypes.BasicPlan &&
                x.coffeeType === this.coffeeTypesObject.FilterCoffee) ||
              x.coffeeType === this.coffeeTypesObject.ColdBrew
            ) {
              updatedCoffeeSizeList.push({
                id: x.id,
                milkyCode: x.milkyCode,
                name: x.name,
                withoutMilkyCode: x.withoutMilkyCode,
                coffeeOptionId: x.coffeeOptionId,
              })
            }
          })

        if (this.$refs.form.validate()) {
          this.snackbar = true
          let updateVenueData = {
            id: this.venueData.id,
            venueName: this.venueData.venueName,
            companyId: this.venueData.companyId,
            address: this.venueData.address,
            selectVenueStore:
              this.selectVenueStore.type == null
                ? this.selectVenueStore
                : this.selectVenueStore.type,
            isOpen: this.isOpen,
            latitude: this.venueData.latitude,
            longitude: this.venueData.longitude,
            milkTypeId: this.milkTypeId,
            resourceId: this.resourceId,
            coffeeSizeList: updatedCoffeeSizeList,
            workingHourList: this.workingHourList,
            venueImageList: [],
            venueExecutiveList: this.venueExecutiveList,
            districtId: this.venueData.districtId,
            cityId: this.venueData.cityId,
            hasPlusPackage:
              this.selectedPlanType === this.planTypes.BasicPlusPlan,
            isBusy: this.busyFreeRadioGroup === 'Yoğun' ? true : false,
            busyEndTime: this.busyEndTimeFormatter(),
            isFree: this.busyFreeRadioGroup === 'Tatil' ? true : false,
            freeEndDate: this.venueData.freeEndDate,
            isComingSoon: this.isComingSoon,
          }

          for (let i = 0; i < updateVenueData.workingHourList.length; i++) {
            if (!updateVenueData.workingHourList[i].close) {
              if (
                typeof updateVenueData.workingHourList[i].openHour !== 'object'
              ) {
                updateVenueData.workingHourList[i].openHour = {
                  HH: updateVenueData.workingHourList[i].openHour.split(':')[0],
                  mm: updateVenueData.workingHourList[i].openHour.split(':')[1],
                }
              }
              if (
                typeof updateVenueData.workingHourList[i].closeHour !== 'object'
              ) {
                updateVenueData.workingHourList[i].closeHour = {
                  HH: updateVenueData.workingHourList[i].closeHour.split(
                    ':',
                  )[0],
                  mm: updateVenueData.workingHourList[i].closeHour.split(
                    ':',
                  )[1],
                }
              }
              const workingHourListControl = this.workingHourControl(
                updateVenueData.workingHourList[i].openHour,
                updateVenueData.workingHourList[i].closeHour,
              )
              if (workingHourListControl === true) {
                return
              }
              const openHour =
                updateVenueData.workingHourList[i].openHour.HH +
                ':' +
                updateVenueData.workingHourList[i].openHour.mm
              const closeHour =
                updateVenueData.workingHourList[i].closeHour.HH +
                ':' +
                updateVenueData.workingHourList[i].closeHour.mm
              updateVenueData.workingHourList[i].openHour = openHour
              updateVenueData.workingHourList[i].closeHour = closeHour
            } else {
              updateVenueData.workingHourList[i].openHour = '00:00'
              updateVenueData.workingHourList[i].closeHour = '00:00'
            }
          }

          // if (
          //   updateVenueData.workingHourList.every(
          //     (x) => x.openHour && x.closeHour,
          //   )
          // ) {
          //   for (let i = 0; i < updateVenueData.workingHourList.length; i++) {
          //     /*if(updateVenueData.workingHourList[i].openHour>updateVenueData.workingHourList[i].closeHour) {
          //           alert("Açılış saati kapanış saatinden büyük olamaz.");
          //           return;
          //         }else*/
          //     if (
          //       this.workingHourControl(
          //         updateVenueData.workingHourList[i].openHour,
          //         updateVenueData.workingHourList[i].closeHour,
          //       )
          //     ) {
          //       return
          //     }
          //     if (updateVenueData.workingHourList[i].close == true) {
          //       updateVenueData.workingHourList[i].openHour = '00:00'
          //       updateVenueData.workingHourList[i].closeHour = '00:00'
          //     }
          //   }
          // } else {
          //   this.errorList = []
          //   this.errorList.push('Girilen saatleri kontrol edin.')
          //   this.dialog = true
          //   return;
          // }
          let milkControl = this.venueMilkControl()
          if (!milkControl) {
            this.errorList = []
            this.errorList.push('Lütfen en az 1 tane süt tercihi yapınız')
            this.dialog = true
            return
          }
          if (
            this.busyEndTimeControl(
              this.venueData.busyEndTime,
              this.isBusyOrFree,
              this.busyFreeRadioGroup,
            )
          )
            return

          if (this.isRequiredFreeEndDate()) return

          Promise.all(
            this.venueImageList.map((item) => {
              if (item.file != null) {
                return this.getBase64(item.file).then((data) => {
                  updateVenueData.venueImageList.push(data)
                })
              } else {
                return updateVenueData.venueImageList.push(item.imagePath)
              }
            }),
          ).then((data) => {
            if (this.venueMapImage != undefined) {
              this.getBase64(this.venueMapImage)
                .then((data) => {
                  updateVenueData.mapImage = data
                })
                .then(() => {
                  updateVenueData.workingHourList.forEach((item) => {
                    delete item.name
                    delete item.startModal2
                    delete item.endModal2
                    delete item.close
                    delete item.tempCloseHour
                    delete item.tempOpenHour
                    delete item.tempClose
                  })
                  this.updateVenue(updateVenueData)
                    .then((res) => {
                      // this.routeReaderAppUsers();
                      if (res.processStatus == 'Success') {
                        alert('Güncelleme işlemi başarılıdır.')
                        this.routeVenues()
                      } else {
                        alert(res.friendlyMessage.message)
                      }
                    })
                    .catch((err) => {
                      const res = err.response.data
                      this.errorList = []
                      this.errorList = Object.values(res.errors).flat()
                      this.dialog = true
                    })
                })
            } else {
              updateVenueData.workingHourList.forEach((item) => {
                delete item.name
                delete item.startModal2
                delete item.endModal2
                delete item.close
                delete item.tempCloseHour
                delete item.tempOpenHour
                delete item.tempClose
              })
              this.updateVenue(updateVenueData)
                .then((res) => {
                  // this.routeReaderAppUsers();
                  if (res.processStatus == 'Success') {
                    alert('Güncelleme işlemi başarılıdır.')
                    this.routeVenues()
                  } else {
                    this.errorList = []
                    this.errorList = Object.values(res.errors).flat()
                    this.dialog = true
                  }
                })
                .catch((err) => {
                  const res = err.response.data
                  const msgKey = res.friendlyMessage.message
                  if (msgKey) {
                    if (this.allErrorList[msgKey]) {
                      this.errorList = [this.allErrorList[msgKey]]
                    } else {
                      this.errorList = [this.allErrorList['general']]
                    }
                  } else {
                    this.errorList = []
                    this.errorList = Object.values(res.errors).flat()
                  }
                  this.dialog = true
                })
            }
          })
        } else {
          var errors = []
          var x = document.getElementsByClassName('v-messages__message')
          for (var i = 0; i < x.length; i++) errors.push(x[i].innerHTML)

          this.errorList = errors

          this.dialog = true
        }
      }
    },
    syncWorkingHoursForOpen() {
      const monday = this.workingHourList.find(
        (day) => day.workingDay === 'Monday',
      )
      if (monday.close === true || monday.openHour === '00:00') return

      if (monday.openHour !== monday.tempOpenHour) {
        this.workingHourList.forEach((day) => {
          if (day.workingDay !== 'Monday' && day.close === false) {
            day.openHour = monday.openHour
          }
        })
      }
    },
    syncWorkingHoursForClose() {
      const monday = this.workingHourList.find(
        (day) => day.workingDay === 'Monday',
      )
      if (monday.close === true) {
        return
      }
      if (
        monday.closeHour !== monday.tempCloseHour ||
        monday.close !== monday.tempClose
      ) {
        this.workingHourList.forEach((day) => {
          if (day.workingDay !== 'Monday' && day.close === false) {
            day.closeHour = monday.closeHour
          }
        })
      }
    },
    coffeeOptionForPlanTypes(coffeeOption) {
      return (
        (this.selectedPlanType === this.planTypes.BasicPlan &&
          (coffeeOption.coffeeType === this.coffeeOptionsForBasicPlan[0] ||
            coffeeOption.coffeeType === this.coffeeOptionsForBasicPlan[1])) ||
        this.selectedPlanType === this.planTypes.BasicPlusPlan
      )
    },
    changeSelectedPlanType() {
      if (this.selectedPlanType === this.planTypes.BasicPlan) {
        this.selectedPlanType = this.planTypes.BasicPlusPlan
      } else {
        this.selectedPlanType = this.planTypes.BasicPlan
      }
    },
    busyEndTimeFormatter() {
      if (
        this.venueData.busyEndTime !== null &&
        this.venueData.busyEndTime !== undefined
      ) {
        if (typeof this.venueData.busyEndTime !== 'object') {
          this.venueData.busyEndTime = {
            HH: this.venueData.busyEndTime.split(':')[0],
            mm: this.venueData.busyEndTime.split(':')[1],
          }
        }
        const busyEndTime =
          this.venueData.busyEndTime.HH + ':' + this.venueData.busyEndTime.mm
        return busyEndTime
      }
    },
    busyEndTimeControl(time, isBusyOrFree, busyFreeRadioGroup) {
      if (
        (time === undefined ||
          time === null ||
          time === '' ||
          time.HH === '' ||
          time.mm === '') &&
        isBusyOrFree &&
        busyFreeRadioGroup === 'Yoğun'
      ) {
        this.errorList = []
        this.errorList.push('Yoğunluk bitiş saati girişi yapmalısınız!')
        this.dialog = true
        return true
      } else if (
        time !== undefined &&
        time !== null &&
        time !== '' &&
        isBusyOrFree &&
        busyFreeRadioGroup === 'Yoğun'
      ) {
        if (
          (parseInt(time.HH) === this.currentHour &&
            parseInt(time.mm) < this.currentMinute) ||
          parseInt(time.HH) < this.currentHour
        ) {
          this.errorList = []
          this.errorList.push('Saat mevcut saatten geride olamaz!')
          this.dialog = true
          return true
        }
      } else return false
    },
    isRequiredFreeEndDate() {
      if (
        this.isBusyOrFree &&
        this.busyFreeRadioGroup === 'Tatil' &&
        (this.venueData.freeEndDate === null ||
          this.venueData.freeEndDate === '' ||
          this.venueData.freeEndDate === undefined)
      ) {
        this.errorList = []
        this.errorList.push('Tatil bitiş tarihi girişi yapmalısınız!')
        this.dialog = true
        return true
      } else {
        return false
      }
    },
    formatDate(date) {
      if (!date) return null
      this.venueData.freeEndDate = moment(date, 'YYYY-MM-DD').format(
        'DD-MM-YYYY',
      )
      return this.venueData.freeEndDate
    },
    handleRadioChange() {
      if (this.busyFreeRadioGroup === 'Yoğun') {
        this.menu = false
      }
    },
  },
  // mounted() {
  //  this.formatDate(this.venueData.freeEndDate)
  // },
}
</script>
<style>
/* #coffee0 {
  margin-top: 27px;
}
#coffee1 {
  margin-top: 22px!important;
} */
</style>
<style scoped>
.label {
  font-size: 0.8125rem;
  margin-bottom: 0.375rem;
  color: rgba(0, 0, 0, 0.6);
}

.hour-icon {
  display: inline-block;
  vertical-align: middle;
  margin-bottom: -2px;
}

.input-container {
  display: flex;
  align-items: center;
}

.input-container input {
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 0;
}
</style>
